export const stringToPastelColor = (str) => {
    if (!str) return 'hsl(0, 0%, 90%)'; // default light gray
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    // Generate pastel colors by mixing with white (high lightness, medium saturation)
    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 70%, 85%)`;
};

export const stringToDarkColor = (str) => {
    if (!str) return 'hsl(0, 0%, 30%)'; // default dark gray
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 70%, 30%)`; // Darker version for text/borders
};
